import React, { useEffect, useState } from "react";
import { API } from "../../config/api";

export default function ViewHiring() {
  const [hiringList, setHiringList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);

  const [selectedHiring, setSelectedHiring] = useState(null);

  const [showModal, setShowModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");

  const [statusFilter, setStatusFilter] = useState("all");

  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  useEffect(() => {
    fetchHiring();
  }, []);

  useEffect(() => {
    filterHiring();
    setCurrentPage(1);
  }, [searchTerm, statusFilter, hiringList]);

  const fetchHiring = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API.GET_ALL_HIRING}`);

      const data = await res.json();

      if (data.success) {
        setHiringList(data.data);
      } else {
        setHiringList([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const filterHiring = () => {
    let list = [...hiringList];

    if (statusFilter !== "all") {
      list = list.filter(
        (item) =>
          item.status &&
          item.status.toLowerCase() === statusFilter.toLowerCase(),
      );
    }

    if (searchTerm.trim() !== "") {
      const term = searchTerm.toLowerCase();

      list = list.filter(
        (item) =>
          item.name.toLowerCase().includes(term) ||
          item.mobile.includes(term) ||
          item.address.toLowerCase().includes(term) ||
          item.details.toLowerCase().includes(term) ||
          item.user_id.toString().includes(term),
      );
    }

    setFilteredList(list);
  };

  const handleView = (item) => {
    setSelectedHiring(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedHiring(null);
  };

  const handleStatus = async (status) => {
    try {
      const formData = new FormData();

      formData.append("id", selectedHiring.id);
      formData.append("status", status);

      const res = await fetch(API.UPDATE_HIRING_STATUS, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      alert(data.message);

      if (data.success) {
        fetchHiring();
        handleClose();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleReject = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to reject this hiring advertisement?",
    );

    if (!confirmDelete) return;

    try {
      const formData = new FormData();

      formData.append("id", selectedHiring.id);

      const res = await fetch(API.DELETE_HIRING, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      alert(data.message);

      if (data.success) {
        fetchHiring();
        handleClose();
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Pagination
  const totalPages = Math.ceil(filteredList.length / itemsPerPage);

  const paginatedList = filteredList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="pds-dashboard-container">
      <h2 className="pds-main-title">Hiring Advertisements</h2>

      {/* Search & Filter */}
      <div className="pds-filter-panel">
        <div className="pds-control-group">
          <label className="pds-control-label">Search</label>
          <input
            type="text"
            className="pds-input-field"
            placeholder="Search by name, mobile, address..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="pds-control-group">
          <label className="pds-control-label">Status</label>

          <select
            className="pds-select-field"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All</option>
            <option value="Pending">Pending</option>
            <option value="Active">Active</option>
            <option value="Hide">Hide</option>
          </select>
        </div>
      </div>

      {/* Table */}

      <div className="pds-table-responsive">
        <table className="pds-custom-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User ID</th>
              <th>Date</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="pds-table-empty-state">
                  Loading...
                </td>
              </tr>
            ) : filteredList.length === 0 ? (
              <tr>
                <td colSpan="7" className="pds-table-empty-state">
                  No Hiring Advertisement Found.
                </td>
              </tr>
            ) : (
              paginatedList.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    {filteredList.length -
                      ((currentPage - 1) * itemsPerPage + index)}
                  </td>

                  <td>{item.user_id}</td>

                  <td>
                    <div className="pds-date-text">
                      {new Date(item.created_at).toLocaleDateString()}
                    </div>

                    <div className="pds-time-text">
                      {new Date(item.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>

                  <td className="pds-highlight-cell">{item.name}</td>

                  <td>{item.mobile}</td>

                  <td>
                    <span
                      className={`pds-status-badge ${
                        item.status === "Active"
                          ? "pds-badge-active"
                          : item.status === "Hide"
                            ? "pds-badge-hide"
                            : "pds-badge-pending"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="pds-action-btn-view"
                        onClick={() => handleView(item)}
                      >
                        <i className="bi bi-eye"></i>
                      </button>
                    </div>
                  </td>
                  {/* <td>
                    <button
                      className="pds-action-btn-view"
                      onClick={() => handleView(item)}
                    >
                      View Details
                    </button>
                  </td> */}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "8px",
            marginTop: "20px",
          }}
        >
          <button
            className="pds-btn pds-btn-secondary"
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          >
            Previous
          </button>

          {[...Array(totalPages)].map((_, i) => {
            const page = i + 1;

            return (
              <button
                key={page}
                className="pds-btn"
                style={{
                  background: currentPage === page ? "#11867f" : "#e5e7eb",
                  color: currentPage === page ? "#fff" : "#000",
                }}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            );
          })}

          <button
            className="pds-btn pds-btn-secondary"
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal */}

      {showModal && selectedHiring && (
        <div className="pds-modal-backdrop">
          <div className="pds-modal-wrapper">
            <div className="pds-modal-header">
              <h3>Hiring Advertisement</h3>

              <button className="pds-modal-close-x" onClick={handleClose}>
                &times;
              </button>
            </div>

            <div className="pds-modal-body">
              <div className="pds-modal-right-column">
                <div className="pds-grid-system">
                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Hiring Name</span>

                    <span className="pds-detail-val">
                      {selectedHiring.name}
                    </span>
                  </div>

                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Mobile Number</span>

                    <span className="pds-detail-val">
                      {selectedHiring.mobile}
                    </span>
                  </div>

                  <div className="pds-grid-item pds-col-fullwidth">
                    <span className="pds-detail-label">Address</span>

                    <p className="pds-detail-paragraph">
                      {selectedHiring.address}
                    </p>
                  </div>

                  <div className="pds-grid-item pds-col-fullwidth">
                    <span className="pds-detail-label">Details</span>

                    <p className="pds-detail-paragraph">
                      {selectedHiring.details}
                    </p>
                  </div>

                  {/* <div className="pds-grid-item">
                    <span className="pds-detail-label">Status</span>

                    <span
                      className={`pds-status-badge ${
                        selectedHiring.status === "Active"
                          ? "pds-badge-active"
                          : "pds-badge-pending"
                      }`}
                    >
                      {selectedHiring.status}
                    </span>
                  </div> */}
                </div>
              </div>
            </div>

            <div className="pds-modal-footer">
              <button
                className="pds-btn pds-btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>

              {/* <button
                className="pds-btn pds-btn-primary"
                onClick={handleUpdate}
              >
                Update
              </button> */}

              {selectedHiring.status === "Pending" && (
                <button
                  className="pds-btn pds-btn-success"
                  onClick={() => handleStatus("Active")}
                >
                  Active
                </button>
              )}

              {selectedHiring.status === "Active" && (
                <button
                  className="pds-btn"
                  style={{
                    background: "#a5220b",
                    color: "#fff",
                  }}
                  onClick={() => handleStatus("Hide")}
                >
                  Hide
                </button>
              )}

              {selectedHiring.status === "Hide" && (
                <button
                  className="pds-btn pds-btn-success"
                  onClick={() => handleStatus("Active")}
                >
                  Unhide
                </button>
              )}

              <button className="pds-btn pds-btn-danger" onClick={handleReject}>
                Reject
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
